import { goalCondition } from './segment-behaviors/goal-condition.value';
import { appVersionCondition } from './segment-common/app-version-condition.value';
import { carrierCondition } from './segment-common/carrier-condition.value';
import { connectionCondition } from './segment-common/connection-condition.value';
import { deviceModelCondition } from './segment-technologies/device-model-condition.value';
import { isReturningCondition } from './segment-common/is-returning-condition.value';
import { languageCondition } from './segment-common/language-condition.value';
import { numberPageviewsCondition } from './segment-behaviors/number-pageviews-condition.value';
import { numberVisitsCondition } from './segment-common/number-visits-condition.value';
import { osVersionCondition } from './segment-technologies/os-version-condition.value';
import { transactionCondition } from './segment-behaviors/transaction-condition.value';
import { visitDurationCondition } from './segment-behaviors/visit-duration-condition.value';
export const sdkSegmentConditions = [
    deviceModelCondition,
    osVersionCondition,
    appVersionCondition,
    carrierCondition,
    connectionCondition,
    isReturningCondition,
    languageCondition,
    numberVisitsCondition,
    numberPageviewsCondition,
    transactionCondition,
    visitDurationCondition,
    goalCondition,
];
//# sourceMappingURL=index.js.map